up.compiler('[eager-preload]', function(link) {
  up.link.preload(link)
})
